import { HttpStatusCodes } from '@naverpay/es-http-status-codes';
import { MfaInfoErrorCode, MfaInfoFailCode } from '../response/mfa.mjs';
import { DEFAULT_URL } from './common.mjs';
const MFA_PASSWORD_CHECK = '/authentication/pw/check';
export function getMfaRedirectUrl(params) {
    const { statusCode, mfaInfo, rurl, surl } = params;
    // status code가 400 이하라면 무시
    if (statusCode < HttpStatusCodes.BAD_REQUEST) {
        return undefined;
    }
    // 500 에러 처리 (param error, internal server error, 페이회원 미정의, 페이회원 api error)
    if (statusCode === HttpStatusCodes.INTERNAL_SERVER_ERROR && mfaInfo.code === MfaInfoErrorCode) {
        return (params === null || params === void 0 ? void 0 : params.errorUrl) || DEFAULT_URL.ERROR;
    }
    if (statusCode === HttpStatusCodes.FORBIDDEN && mfaInfo.code === MfaInfoFailCode.SessionFail) {
        const { sessionKey } = mfaInfo;
        const mfaPasswordCheckUrl = `${MFA_PASSWORD_CHECK}?rurl=${encodeURIComponent(rurl)}&surl=${encodeURIComponent(surl)}&sessionKey=${sessionKey}&type=mfa`;
        return mfaPasswordCheckUrl;
    }
}
